import React, { useState, useEffect, useRef } from "react";
import "./BeforeAfter.css";
import smileImage from "./Images/beforeafter/img1.png";

// import smileImage2 from './Images/beforeafter/img2.png';
// import smileImage3 from './Images/beforeafter/img3.jpg';
// import smileImage4 from './Images/beforeafter/img4.jpg';
import dental1 from "../home/Images/v1.png";
import dental2 from "../home/Images/IMG20240913134831.jpg";
import dental3 from "../home/Images/IMG_20231201_174221.jpg";
import dental4 from "../home/Images/dental2.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  FaCoffee,
  FaChild,
  FaClock,
  FaRegCheckCircle,
  FaTv,
  FaCalendarCheck,
  FaTag,
  FaCreditCard,
  FaMedkit,
} from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";

const BeforeAfter = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // Track hover state
  const images = [
    "bef-and-after1",
    "bef-and-after2",
    "bef-and-after3",
    "bef-and-after4",
    "bef-and-after5",
    "bef-and-after6",
    "bef-and-after7",
    "bef-and-after8",
  ];
  const images2 = [
    "bef-and-after11",
    "bef-and-after22",
    "bef-and-after33",
    "bef-and-after44",
    "bef-and-after55",
    "bef-and-after66",
    "bef-and-after77",
    "bef-and-after88",
  ];
  const [imagesPerView, setImagesPerView] = useState(1); // Default to 1 image per view

  // Update imagesPerView based on window width
  useEffect(() => {
    const updateImagesPerView = () => {
      if (window.innerWidth >= 768) {
        setImagesPerView(2); // Show 2 images on larger screens
      } else {
        setImagesPerView(1); // Show 1 image on smaller screens
      }
    };

    updateImagesPerView(); // Set initial value

    window.addEventListener("resize", updateImagesPerView); // Listen for window resize

    return () => window.removeEventListener("resize", updateImagesPerView); // Clean up listener
  }, []);

  const moveToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + imagesPerView) % images.length);
  };

  const moveToPrevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - imagesPerView + images.length) % images.length
    );
  };
  const moveToNextSlide1 = () => {
    setCurrentIndex1((prevIndex) => (prevIndex + imagesPerView) % images.length);
  };

  const moveToPrevSlide1 = () => {
    setCurrentIndex1(
      (prevIndex) => (prevIndex - imagesPerView + images.length) % images.length
    );
  };

  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setCurrentIndex1((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000); // Change slide every 3 seconds
      return () => clearInterval(interval); // Cleanup interval on unmount
    }
  }, [isHovered, images.length]);
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5; // Slow down playback speed (50%)
    }
  }, []);

  const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock size={40} />, label: " Time Management  " },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="beforeafter">
      <div className="beforeafter-sec1">
        <div className="content">
          <div className="text-section">
            <p className="trusted-text">
              <mark className="domark">ABOUT BOMBAY DENTAL CLINIC</mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk"> Building lifetime</mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk"> relationships</mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk">through positive </mark>
            </h1>
            <h1 className="exceptional">
              <mark className="expmrk"> experiences</mark>
            </h1>
            <a href="/booknow">
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
          </div>
        </div>
      </div>

      <div className="home-sec2">
        <div className="home-sec2-box">
          <div className="home-sec2-content">
            <h1 className="Dentist">Transforming Smiles</h1>
            <div className="adultspara2">
              <p className="adults">
                At Bombay Dental, we’re dedicated to delivering exceptional
                care. Since 2011, our dentist have been combining
                state-of-the-art technology with the latest training and
                procedures to create stunning smiles. See the amazing results
                we’ve achieved for our patients.
              </p>
              <a href="/booknow" className="appointment-link">
                Schedule an appointment
              </a>
              <p className="adults">
                to find out how we can transform your smile, too.
              </p>
            </div>
          </div>
          <div className="home-sec2-img">
            <img
              src={smileImage}
              alt="Dental Care"
              style={{
                width: "90%",
                height: "100%",

                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </div>

      {/* Before/After Image Section */}
      <div className="before-after-container">
        <h2 className="title">Before/After:Kids</h2>
      </div>
      <div
        className="custom-carousel-container"
        onMouseEnter={() => setIsHovered(true)} // Pause on hover
        onMouseLeave={() => setIsHovered(false)} // Resume on leave
      >
        <div
          className="custom-carousel"
          style={{
            transform: `translateX(-${currentIndex * (100 / imagesPerView)}%)`, // Move based on imagesPerView
            transition: "transform 0.5s ease-in-out", // Smooth sliding transition
          }}
        >
          {images.map((imageClass, index) => (
            <div key={index} className={`custom-carousel-item ${imageClass}`} />
          ))}
        </div>

        <button className="custom-prev" onClick={moveToPrevSlide}>
          ←
        </button>
        <button className="custom-next" onClick={moveToNextSlide}>
          →
        </button>
      </div>

      <div className="before-after-container">
        <h2 className="title">Before/After: Adults</h2>
      </div>
      <div
        className="custom-carousel-container"
        onMouseEnter={() => setIsHovered(true)} // Pause on hover
        onMouseLeave={() => setIsHovered(false)} // Resume on leave
      >
        <div
          className="custom-carousel-container"
          onMouseEnter={() => setIsHovered(true)} // Pause on hover
          onMouseLeave={() => setIsHovered(false)} // Resume on leave
        >
          <div
            className="custom-carousel"
            style={{
              transform: `translateX(-${
                currentIndex1 * (100 / imagesPerView)
              }%)`, // Move based on imagesPerView
              transition: "transform 0.5s ease-in-out", // Smooth sliding transition
            }}
          >
            {images2.map((imageClass, index) => (
              <div
                key={index}
                className={`custom-carousel-item ${imageClass}`}
              />
            ))}
          </div>

          <button className="custom-prev" onClick={moveToPrevSlide1}>
            ←
          </button>
          <button className="custom-next" onClick={moveToNextSlide1}>
            →
          </button>
        </div>
      </div>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>
      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>

      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
            <a href="/booknow">
              <button className="book-button1">BOOK ONLINE</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfter;
